.field input {
    width: 100px;
}
